export const simpleMarkdownTransform = (markdown: string) =>
  markdown
    ?.replace(/(\*\*)(?!\*)(.*?)\1/g, '<strong>$2</strong>')
    ?.replace(/([*_])(?!\1)(\S[\s\S]*?\S)\1/g, '<em>$2</em>')
    ?.replace(
      /!\[(.*?)\]\((.*?)\s*("(.*?)")?\)/g,
      (_: string, p1: string, p2: string, p3: string, p4: string) =>
        `<img src="${p2}" alt="${p1}"${p3 ? ` title="${p4}"` : ''} />`,
    )
    ?.replace(
      /\[(.*?)\]\((.*?)\s*("(.*?)")?\)/g,
      (_: string, p1: string, p2: string, p3: string, p4: string) =>
        `<a href="${p2}"${p3 ? ` title="${p4}"` : ''}>${p1}</a>`,
    );
